import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import SalesVelocity from "./pages/SalesVelocity";
import SalesReport from "./pages/SalesReport";
import StockReport from "./pages/StockReport";
import Agents from "./pages/Agents";
import Products from "./pages/Products";
import AgentStock from "./pages/AgentStock";
import HouseholdApproval from "./pages/HouseholdApproval";
import AdminGeo from "./pages/AdminGeo";
import StockAllocation from "./pages/StockAllocation";
import OpeningStock from "./pages/OpeningStock";
import PurchaseStock from "./pages/PurchaseStock";
import InventoryLedger from "./pages/InventoryLedger";
import Reports from "./pages/Reports";
import FpoMaster from "./pages/FpoMaster";
import AdminUsers from "./pages/AdminUsers";
import ProductCategories from "./pages/ProductCategories";
import ProductUnits from "./pages/ProductUnits";
import Shareholders from "./pages/Shareholders";
import GeographyMaster from "./pages/GeographyMaster";
import AgentGeoMapping from "./pages/AgentGeoMapping";
import AgentSettlement from "./pages/AgentSettlement";
import Procurement from "./pages/Procurement";
import ProcurementWarehouses from "./pages/ProcurementWarehouses";
import ProcurementDispatchMonitor from "./pages/ProcurementDispatchMonitor";
import StandaloneAggregators from "./pages/StandaloneAggregators";
import WarehouseManagers from "./pages/WarehouseManagers";

import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import "./styles/dashboard.css";

import ChangeAdminPassword from "./pages/ChangeAdminPassword";
import AuthorizedPersons from "./pages/AuthorizedPersons";

function ProtectedRoute({ children, allowedRoles }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role") || "fpo_admin";

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    if (role === "super_admin") {
      return <Navigate to="/super-admin" replace />;
    }

    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function AdminLayout({ children }) {
  return (
    <div className="admin-layout">
      <Sidebar />

      <div className="admin-main">
        <Topbar />

        <main className="admin-page-content">
          {children}
        </main>
      </div>
    </div>
  );
}

function ProtectedAdminPage({ children, allowedRoles }) {
  return (
    <ProtectedRoute allowedRoles={allowedRoles}>
      <AdminLayout>{children}</AdminLayout>
    </ProtectedRoute>
  );
}

function SuperAdminHome() {
  return (
    <div>
      <h2>Super Admin Dashboard</h2>
      <p>
        Super Admin foundation is active. FPO Master and Admin Management are
        available from the left sidebar.
      </p>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/procurement" element={<ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}><Procurement /></ProtectedAdminPage>} />
        <Route path="/procurement/warehouses" element={<ProtectedAdminPage allowedRoles={["fpo_admin"]}><ProcurementWarehouses /></ProtectedAdminPage>} />
        <Route path="/procurement/dispatches" element={<ProtectedAdminPage allowedRoles={["fpo_admin"]}><ProcurementDispatchMonitor /></ProtectedAdminPage>} />
        <Route path="/warehouse-managers" element={<ProtectedAdminPage allowedRoles={["fpo_admin"]}><WarehouseManagers /></ProtectedAdminPage>} />
        <Route path="/standalone-aggregators" element={<ProtectedAdminPage allowedRoles={["fpo_admin"]}><StandaloneAggregators /></ProtectedAdminPage>} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/super-admin"
          element={
            <ProtectedAdminPage allowedRoles={["super_admin"]}>
              <SuperAdminHome />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/admin-users"
          element={
            <ProtectedAdminPage allowedRoles={["super_admin"]}>
              <AdminUsers />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/fpos"
          element={
            <ProtectedAdminPage allowedRoles={["super_admin"]}>
              <FpoMaster />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/masters/product-categories"
          element={
            <ProtectedAdminPage allowedRoles={["super_admin"]}>
              <ProductCategories />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/masters/product-units"
          element={
            <ProtectedAdminPage allowedRoles={["super_admin"]}>
              <ProductUnits />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/masters/geography"
          element={
            <ProtectedAdminPage allowedRoles={["super_admin"]}>
              <GeographyMaster />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/admin-geo"
          element={
            <ProtectedAdminPage allowedRoles={["super_admin"]}>
              <AdminGeo />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/geo-master"
          element={
            <ProtectedAdminPage allowedRoles={["super_admin"]}>
              <GeographyMaster />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <Dashboard />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/dashboard/sales-velocity"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <SalesVelocity />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/agents"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <Agents />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/shareholders"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <Shareholders />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/products"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <Products />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/sales-report"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <SalesReport />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/reports"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <Reports />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/stock-report"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <StockReport />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/stock-allocation"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <StockAllocation />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/agent-stock"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <AgentStock />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/agent-settlement"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <AgentSettlement />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/households/approve"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <HouseholdApproval />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/household-approval"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <HouseholdApproval />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/inventory/opening"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <OpeningStock />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/inventory/purchase"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <PurchaseStock />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/inventory/ledger"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <InventoryLedger />
            </ProtectedAdminPage>
          }
        />

        <Route
          path="/agent-geo-mapping/:agentId"
          element={
            <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
              <AgentGeoMapping />
            </ProtectedAdminPage>
          }
        />
<Route
  path="/change-password"
  element={
    <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
      <ChangeAdminPassword />
    </ProtectedAdminPage>
  }
/>
<Route
  path="/authorized-persons"
  element={
    <ProtectedAdminPage allowedRoles={["fpo_admin", "super_admin"]}>
      <AuthorizedPersons />
    </ProtectedAdminPage>
  }
/>

      </Routes>
    </Router>
  );
}

export default App;
